import styled from "styled-components";

export const StyledColumnsPicker = styled.div`
    flex-grow: 0;
    display: flex;
    align-items: center;
    margin-left: 10px;
`;

export const StyledIcon = styled.div`
    display: inline-block;
    margin-left: 6px;
`;
